import {
    a as r,
    b as l,
    s as u
} from "./utils-BUfVYLTt.js";
class h extends HTMLElement {
    constructor() {
        super(), this.gtmLoader = null, this.handleSubmit = e => {
            var n;
            console.warn("[LocalizationUi] Submit button clicked"), e.preventDefault();
            const t = !((n = this.marketInstances.find(i => i.isoCode === this.selectedCountry)) != null && n.multiStore);
            if (console.warn(`[LocalizationUi] Selected country in market: ${t}`), !this.multiStore || t) {
                console.warn("[LocalizationUi] Submitting native form"), this.setLocaleChoiceCookie(), this.localizationForm.submit();
                return
            }
            const o = this.buildMultiStoreUrl();
            if (!o) {
                console.warn("[LocalizationUi] No redirect URL built");
                return
            }
            console.warn(`[LocalizationUi] Redirecting to: ${o}`), this.setLocaleChoiceCookie(), window.location.href = o
        }, this.storeInstances = [], this.marketInstances = [], this.multiStore = !1, this.currentCountry = "US", this.currentLanguage = "EN", this.persistDays = 28
    }
    connectedCallback() {
        console.warn("[LocalizationUi] Connected callback"), this.getComponentAttributes(), this.cacheDomElements(), this.setEventListeners(), this.multiStore && (console.warn("[LocalizationUi] Multi-store setup detected, normalizing locale data"), this.normalizeLocaleData(), this.updateCountrySelect()), this.checkUserLocaleOnLoad()
    }
    async checkUserLocaleOnLoad() {
        var s;
        console.warn("[LocalizationUi] Checking user locale on load");
        const e = await r();
        if (!e) {
            console.warn("[LocalizationUi] No locale detected");
            return
        }
        const t = e.detected_values.country.handle,
            o = e.detected_values.country.name;
        if (console.warn(`[LocalizationUi] Detected locale: ${t}, country name: ${o}`), t === this.currentCountry) {
            console.warn("[LocalizationUi] Detected locale matches current country, no action needed"), (s = this.gtmLoader) == null || s.setCountry(t);
            return
        }
        const n = l("localization-choice");
        if (console.warn(`[LocalizationUi] Localization choice cookie: ${n || "not set"}`), n) {
            console.warn("[LocalizationUi] User has previously made a localization choice");
            return
        }
        if (!this.marketInstances.find(a => a.isoCode === t)) {
            console.warn(`[LocalizationUi] No supported market found for locale: ${t}`);
            return
        }
        if (!o) {
            console.warn("[LocalizationUi] No country name found");
            return
        }
        console.warn(`[LocalizationUi] Showing choices UI for country: ${o}`), this.showChoicesUi(o)
    }
    showChoicesUi(e) {
        const t = this.querySelector(".localization-ui__title"),
            o = this.querySelector(".localization-ui__text");
        if (t && (e === "United Kingdom" || e === "United States" ? t.textContent = `${t.textContent} the ${e}` : t.textContent = `${t.textContent} ${e}`), o) {
            const n = o.innerText.replace("[replace-here]", e);
            o.innerText = n
        }
        this.shopHereButton && this.shopHereButton.textContent !== null && (this.shopHereButton.textContent = this.shopHereButton.textContent.replace("[replace-here]", (this == null ? void 0 : this.currentCountry) || "GB")), this.localizationForm.classList.add("visually-hidden"), this.choicesForm.classList.remove("visually-hidden"), document.dispatchEvent(new CustomEvent("modal:show:localization"))
    }
    showSettingsUi() {
        this.localizationForm.classList.remove("visually-hidden"), this.choicesForm.classList.add("visually-hidden")
    }
    normalizeLocaleData() {
        var t;
        const e = [];
        for (const o of this.storeInstances) {
            const n = o.supportedCountries.map(i => i.split(":")[0]);
            for (const i of n) {
                const s = {
                    name: ((t = o.supportedCountries.find(a => a.split(":")[0] === i)) == null ? void 0 : t.split(":")[1]) || "",
                    isoCode: i,
                    multiStore: !0,
                    publicUrl: o.publicUrl,
                    shopifyUrl: o.shopifyUrl,
                    isBaseCountry: i === o.baseCountry,
                    languages: this.getNormalizedLanguages(i, o)
                };
                e.push(s)
            }
        }
        this.marketInstances = this.marketInstances.concat(e)
    }
    getNormalizedLanguages(e, t) {
        const o = [],
            n = t.supportedLocales.filter(i => i.endsWith(e)).map(i => i.split("-")[0]);
        for (const i of n) {
            const s = t.supportedLanguages.find(a => a.split(":")[0] === i);
            s && o.push({
                isoCode: i,
                name: s.split(":")[1]
            })
        }
        return o
    }
    cacheDomElements() {
        console.warn("[LocalizationUi] Caching DOM elements");
        const e = this.querySelector(".localization-ui__form");
        e && (this.localizationForm = e);
        const t = this.querySelector('[js-localization-ui="choice"]');
        t && (this.choicesForm = t);
        const o = this.querySelector('[js-localization-ui="country-select"]');
        o && (this.countrySelect = o);
        const n = this.querySelector('[js-localization-ui="language-select"]');
        n && (this.languageSelect = n);
        const i = this.querySelector('[js-localization-ui="submit"]');
        i && (this.submitButton = i);
        const s = this.querySelector('[js-localization-ui="shop-here"]');
        s && (this.shopHereButton = s);
        const a = this.querySelector('[js-localization-ui="change-region"]');
        a && (this.changeRegionButton = a);
    }
    getComponentAttributes() {
        var o, n;
        console.warn("[LocalizationUi] Getting component attributes");
        const e = this.getAttribute("setting-store-instances");
        this.multiStore = this.getAttribute("setting-multi-store") === "true", e && (this.storeInstances = (o = JSON.parse(e)) == null ? void 0 : o.instances);
        const t = this.getAttribute("setting-store-markets");
        t && (this.marketInstances = (n = JSON.parse(t)) == null ? void 0 : n.markets), this.currentCountry = this.getAttribute("setting-current-country"), this.selectedCountry = this.currentCountry, this.currentLanguage = this.getAttribute("setting-current-language"), this.selectedLanguage = this.currentLanguage, this.persistDays = parseInt(this.getAttribute("setting-persist-days") || "28"), console.warn(`[LocalizationUi] Current country: ${this.currentCountry}, language: ${this.currentLanguage}`), console.warn(`[LocalizationUi] Persist days: ${this.persistDays}`)
    }
    updateCountrySelect() {
        if (!this.countrySelect) return;
        this.countrySelect.innerHTML = "";
        const e = document.createElement("option");
        e.value = "", e.disabled = !0, e.textContent = window.themeVars.strings.localization.country_default, this.countrySelect.appendChild(e);
        for (const t of this.marketInstances) {
            const o = document.createElement("option");
            o.value = t.isoCode, o.textContent = `${t.name} - ${t.isoCode}`, o.selected = t.isoCode === this.currentCountry, o.dataset.multiStore = (!!(t != null && t.multiStore)).toString(), this.countrySelect.appendChild(o)
        }
    }
    setEventListeners() {
        console.warn("[LocalizationUi] Setting up event listeners"), this.countrySelect && this.countrySelect.addEventListener("change", e => {
            const t = e.target,
                o = t.options[t.selectedIndex];
        }), this.languageSelect && this.languageSelect.addEventListener("change", e => {
            const t = e.target,
                o = t.options[t.selectedIndex];
            this.selectedLanguage = o.value, console.warn(`[LocalizationUi] Language select changed to: ${this.selectedLanguage}`)
        }), this.submitButton && (console.warn("[LocalizationUi] Adding submit button listener"), this.submitButton.addEventListener("click", this.handleSubmit)), this.shopHereButton && this.shopHereButton.addEventListener("click", () => {
            console.warn("[LocalizationUi] Shop here button clicked"), document.dispatchEvent(new CustomEvent("modal:hide:localization"))
        }), this.changeRegionButton && this.changeRegionButton.addEventListener("click", () => {
            console.warn("[LocalizationUi] Change region button clicked"), this.showSettingsUi()
        }), document.addEventListener("modal:closed:localization", () => {
            console.warn("[LocalizationUi] Modal closed event received"), this.setLocaleChoiceCookie()
        })
    }
    setLocaleChoiceCookie() {
        const e = `${this.selectedLanguage ? this.selectedLanguage : this.currentLanguage}-${this.selectedCountry ? this.selectedCountry : this.currentCountry}`;
        console.warn(`[LocalizationUi] Setting localization choice cookie: ${e} for ${this.persistDays} days`), u("localization-choice", e, this.persistDays)
    }
    buildMultiStoreUrl() {
        const e = this.marketInstances.find(s => s.isoCode === this.selectedCountry),
            t = this.storeInstances.find(s => s.supportedCountries.includes(`${this.selectedCountry}:${e == null ? void 0 : e.name}`));
        if (!e || !t) return;
        const o = new URL(window.location.href),
            n = new URL((e == null ? void 0 : e.publicUrl) || "");
        if (o.origin === n.origin) {
            this.localizationForm.submit();
            return
        }
        const i = this.buildLocale(t, this.selectedCountry || "gb", this.selectedLanguage || "en");
        return this.buildRedirectUrl(n, o, i)
    }
    buildRedirectUrl(e, t, o) {
        const n = this.removeLocaleFromPath(t.pathname),
            i = e.origin,
            s = t.search,
            a = t.hash,
            c = new URL(i);
        return c.pathname = o ? `/${o}/${n}` : n, c.search = s, c.hash = a, c.toString()
    }
    buildLocale(e, t, o) {
        let n = "";
        return t && t !== e.baseCountry ? o && (n = `${o.toLowerCase()}-${t.toLowerCase()}`) : o && o !== e.baseLanguage && (n = o.toLowerCase()), n
    }
    removeLocaleFromPath(e) {
        const t = /^(\/?)(?:[a-z]{2}-[a-z]{2}|[a-z]{2})(\/|$)/;
        return e.replace(t, "")
    }
    updateLanguageSelect() {
        var o;
        console.warn(`[LocalizationUi] Updating language select for country: ${this.selectedCountry}`);
        const e = this.marketInstances.find(n => n.isoCode === this.selectedCountry);
        if (!e || !this.languageSelect) {
            console.warn("[LocalizationUi] Market instance or language select not found");
            return
        }
        this.languageSelect.innerHTML = "";
        const t = document.createElement("option");
        t.value = "", t.disabled = !0, t.textContent = window.themeVars.strings.localization.language_default, this.languageSelect.appendChild(t), e.languages.find(n => n.isoCode === this.selectedLanguage) || (console.warn(`[LocalizationUi] Selected language not found in market, defaulting to first language: ${(o = e.languages[0]) == null ? void 0 : o.isoCode}`), this.selectedLanguage = e.languages[0].isoCode), console.warn(`[LocalizationUi] Adding ${e.languages.length} language options to select`);
        for (const n of e.languages) {
            const i = document.createElement("option");
            i.value = n.isoCode, i.textContent = n.name, i.selected = n.isoCode === this.selectedLanguage, this.languageSelect.appendChild(i)
        }
    }
}
customElements.define("uwp-localization-ui", h);